
<!-- <div *ngIf="isloading" class="p-5"
    style="display: flex; justify-content: center;align-items: center; text-align: center; height: 80vh; width: 80vw;">
    <app-loading-spinner></app-loading-spinner>
</div> -->

<div class="card h-100 mx-auto" aria-labelledby="submit-exam-header">
    <!-- Card header -->
    <div class="card-header submit-exam">
        <!-- Title -->
        <h5 id="submit-exam-header" class="mb-0">{{(linkedExams?.length < 1 ? language.submitExamination : language.linkedExaminations)}}</h5>
    </div>
    <!-- Card image -->
    <!-- List group -->
    <!-- Card body -->
    <div class="card-body d-flex flex-column align-items-center justify-content-center w-100">
        <div *ngIf="!msg && !isloading" class="home-text" style="width: 90%; text-align: center;" role="alert"
            aria-labelledby="confirm-header">
            <h2 id="confirm-header" class="mb-5">{{language.submitConfirmationMessage}}</h2>
            <button class="btn btn-lg btn-primary  mr-5" (click)="noclicked()" [disabled]="this.submitting">
                <span style="color: white !important;">{{language.no}}</span>
            </button>
        
            <button class="btn btn-lg btn-danger" (click)="yesclicked()" [disabled]="this.submitting">
                <span style="color: white !important;">{{this.submitting ? language.submitting : language.yes}}</span>
            </button>
        </div>
        <app-examfeedback #feedmodal></app-examfeedback>
        <div *ngIf="msg && linkedExams?.length < 1" class="h2 mb-5" style="width: 90% ; text-align: center;" id="exammessage" [innerHTML]="msg" role="alert">
        </div>
        <div *ngIf="postmsg && linkedExams?.length < 1" class="h2 mb-5" style="width: 90% ; text-align: center;" id="exammessage" [innerHTML]="postmsg" role="alert">
        </div>
        <div *ngIf="marking" class="h5 mb-5" style="width: 90%; text-align: center;" role="status" aria-live="polite">
            <span>{{language.postSubmitScoreFetching}}</span>
            <div class="spinner-border m-2 text-primary" role="status">
                <span class="sr-only">{{language.loading}}...</span>
            </div>
        </div>
        <div *ngIf="scoreFetchError" class="h4 mb-5" style="width: 90% ; text-align: center;" id="exammessage" role="alert">
            {{language.scoreFetchError}}
        </div>
        <div *ngIf="score && msg" class="h1 mb-5" style="width: 90% ; text-align: center;" role="alert" aria-live="polite">
             {{language.yourScore}} {{score}} ({{percentscore| number:'1.0-0'}}%)
        </div>
        <div *ngIf="msg && linkedExams?.length < 1" style="width: 90%; text-align: center;">
            <a style="cursor:pointer;" class="regular-button start_new_exm" (click)="newexam()" role="button" tabindex="0">{{language.startNewExam}}</a>
        </div>
         <ng-container *ngIf="msg && linkedExams?.length > 0">
            <div class="h2 mb-lg-4" style="width: 90%;" id="exammessage" role="heading" aria-level="2">
                {{ language.youHaveCompleted + " '" + examination.name + "'. "}}
                <br>
                {{language.continueWith + ":" }}
            </div>

           <div class="h-100"style="overflow-y: auto; width: 85%;" aria-label="Subsequent exams list">
                <div class="classmaterial" *ngFor="let exam of linkedExams; let i = index">
                    <app-userexamination [exam]="exam"></app-userexamination>
                    <div class="mt-5"></div>
                </div>
            </div>
        </ng-container>
         
        <div class="d-flex justify-content-center mt-5" style="width: 90%;">
            <a class="complaint" (click)="gotoComplaint()" role="link" tabindex="0">{{language.makeComplaint}}</a>
         </div>
    </div>
</div>
